/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";

import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import ArgonButton from "components/ArgonButton";
import { Link } from "react-router-dom";

function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="full" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

function StudentData({ student, client }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {student}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        Client-{client}
      </ArgonTypography>
    </ArgonBox>
  );
}

// Attendance component
function AttendanceProgress({ percentage, label = "Attendance" }) {
  return (
    <ArgonBox>
      {/* Label */}
      <ArgonBox display="flex" justifyContent="space-between" mb={1}>
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {"12 July 2024"}
        </ArgonTypography>
      </ArgonBox>

      {/* Progress Bar Container */}
      <ArgonBox
        width="180%"
        height="10px"
        bgColor="grey-200"
        borderRadius="lg"
        position="relative"
        overflow="hidden"
      >
        {/* Progress Fill */}
        <ArgonBox
          width={`${percentage}%`}
          height="100%"
          // bgColor={percentage >= 80 ? "success" : percentage >= 60 ? "warning" : "error"}
          bgColor="primary"
          borderRadius="lg"
          position="absolute"
          top={0}
          left={0}
        />
      </ArgonBox>
    </ArgonBox>
  );
}

const authorsTableData = {
  columns: [
    { name: "Cycle Name", align: "left" },
    { name: "Total Classes", align: "center" },
    { name: "Completed Classes", align: "center" },
    { name: "Status", align: "center" },
  ],

  rows: [
    {
      Date: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {"24 july 2024"}
        </ArgonTypography>
      ),
      Attendance: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {"Regular"}
        </ArgonTypography>
      ),
      "Per class fee": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {"100"}
        </ArgonTypography>
      ),
      Tutor: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {"Adil"}
        </ArgonTypography>
      ),
      type: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          Monthly
        </ArgonTypography>
      ),
      status: (
        <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />
      ),
      "last payment date": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          15 Dec 2024
        </ArgonTypography>
      ),
      action: (
        <ArgonBox display="flex" alignItems="center" gap={0}>
          {/* View Icon */}
          <ArgonButton
            variant="text"
            size="large"
            component={Link}
            to="/creditmapping/view"
            sx={{ minWidth: "12px", p: 0 }}
          >
            <VisibilityIcon color="primary" />
          </ArgonButton>
          {/* Delete icon */}
          <ArgonButton
            variant="text"
            size="large"
            sx={{ minWidth: "32px", p: 0 }}
            onClick={() => handleDeleteClick()}
          >
            <DeleteIcon color="error" />
          </ArgonButton>
        </ArgonBox>
      ),
    },
  ],
};

export default authorsTableData;
